export const environment = {
    URL: 'https://back.evocredito.credienlinea.co',
    USER: 'evocredito',
    PASS: 'cpr6wMw0Eo43BFL',
    ENTERPRISE: 'Evocredito',
    SINGLEROUTE: true,
    PLAYROUTE: true,
  };
